import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { CountdownTimer } from './CountdownTimer';
import { FlowLine } from './FlowLine';
import { Ornament } from './Ornament';
export function BonusSection() {
  return <section className="border-y border-primary/10 bg-background px-4 py-20 sm:py-28" data-id="element-21" data-mp="1ydi6yabp1vla">
      <div className="mx-auto max-w-6xl" data-id="element-22" data-mp="1ao7dzf0l55hp">
        <div className="text-center" data-id="element-23" data-mp="1ap8rdq52q42l">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary" data-id="element-24" data-mp="1am2ydztbqi1l">
            Your 6-in-1 system doesn’t stop there
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-foreground sm:text-4xl" data-id="element-25" data-mp="1jhsoun9mq2lu">
            5 Professional Bonus Guides{' '}
            <span className="italic text-primary" data-id="element-26" data-mp="1eor6g5a7rkxi">at No Additional Cost</span>
          </h2>
          <Ornament className="mt-5" data-id="element-27" data-mp="qyn7ib7z09cu" />
          <p className="mx-auto mt-4 max-w-2xl text-base leading-7 text-muted-foreground" data-id="element-28" data-mp="mz4lfc4exs8f">
            Along with the complete six-volume visual teaching system, you also
            receive:
          </p>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-29" data-mp="2eqecbparfzte">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col overflow-hidden rounded-xl border border-accent/40 bg-surface shadow-card ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-30" data-mp="2jj7h2d68b85h" data-mpi={index}>
              <div className="flex items-center justify-between gap-3 border-b border-accent/25 px-6 py-4" data-id="element-31" data-mp="25o54562ysij6">
                <span className="font-display text-2xl font-semibold text-primary" data-id="element-32" data-mp="3h5mwzaj0bxqx">
                  BONUS {bonus.id}
                </span>
                <span className="flex h-10 w-10 items-center justify-center rounded-full border border-accent/60 text-accent" data-id="element-33" data-mp="1h2c7n680wmkg">
                  <GiftIcon size={18} strokeWidth={1.5} aria-hidden="true" data-id="element-34" data-mp="1c42c2uidzjyb" />
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-35" data-mp="1q1r02b7r377l">
                <h3 className="text-xl font-semibold leading-snug text-foreground" data-id="element-36" data-mp="1m3ta3665oh35">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm font-semibold leading-6 text-primary-strong" data-id="element-37" data-mp="yajg7g8lr9eu">
                  {bonus.tagline}
                </p>
                {bonus.intro.map(paragraph => <p key={paragraph} className="mt-3 text-sm leading-6 text-muted-foreground" data-id="element-38" data-mp="17728qrcx8vaw">
                    {paragraph}
                  </p>)}
                <p className="mt-4 text-sm font-semibold text-foreground" data-id="element-39" data-mp="anl1oo41mbjk">
                  {bonus.listLabel}
                </p>
                <ChipList items={bonus.bullets} data-id="element-40" data-mp="id2pje5kp6d" />
                {bonus.flow && <FlowLine className="mt-5" label={bonus.flow.label} steps={bonus.flow.steps} data-id="element-41" data-mp="5acyczn6wvx5" />}
                {bonus.extraList && <>
                    <p className="mt-5 text-sm font-semibold text-foreground" data-id="element-42" data-mp="3rncwv6uf822d">
                      {bonus.extraList.label}
                    </p>
                    <ChipList items={bonus.extraList.items} data-id="element-43" data-mp="o7xp6c9im4ke" />
                  </>}
                {bonus.note && <p className="mt-4 text-sm leading-6 text-muted-foreground" data-id="element-44" data-mp="9bghbv0jb82l">
                    {bonus.note}
                  </p>}
                {bonus.closing && <p className="mt-4 text-sm font-medium leading-6 text-foreground" data-id="element-45" data-mp="2u0dy8qk64k1u">
                    {bonus.closing}
                  </p>}
                <p className="mt-auto pt-6" data-id="element-46" data-mp="3f8omsv9mtk56">
                  <span className="inline-flex rounded-full bg-surface-subtle px-3 py-1.5 text-xs font-bold uppercase tracking-[0.08em] text-primary-strong" data-id="element-47" data-mp="3f9hkl6qm4zb6">
                    Included at no additional cost
                  </span>
                </p>
              </div>
            </motion.article>)}
        </div>
        <CountdownTimer data-id="element-48" data-mp="21mu5cml6979" />
      </div>
    </section>;
}
function ChipList({
  items
}: {
  items: string[];
}) {
  return <ul className="mt-2.5 flex flex-wrap gap-1.5" data-id="element-49" data-mp="3t7eic6gszbrf">
      {items.map(item => <li key={item} className="rounded-full border border-primary/15 bg-background px-2.5 py-1 text-xs font-medium text-foreground" data-id="element-50" data-mp="3o8ushuz39fts">
          {item}
        </li>)}
    </ul>;
}